/* eslint-disable no-redeclare */
import { TextEditor } from '@botco/library';

export const DEFAULT_DISABLED_ATTRS = ['_transcript'] as const;

export type DEFAULT_DISABLED_ATTRS = (typeof DEFAULT_DISABLED_ATTRS)[number];

const ATTRIBUTE_CHIP_CONFIG: Record<string, TextEditor.ChipConfig> = {
  _transcript: {
    disabled: true, // <-- Disabled by default
    tooltipMessage: 'The _transcript attribute is not enabled in this context.',
  },
};

/**
 * Get configuration for a specific attribute
 * @param attributeName - The name of the attribute to get config for
 * @param enabledAttributes - Optional array of attribute names that should be enabled (overrides disabled config)
 * @returns Configuration object with disabled state and optional tooltip
 */
export const getAttributeChipConfig = (
  attributeName?: string,
  enabledAttributes?: string[]
): TextEditor.ChipConfig => {
  if (!attributeName) {
    return { disabled: false };
  }

  const baseConfig = ATTRIBUTE_CHIP_CONFIG[attributeName] ?? {
    disabled: false,
  };

  if (enabledAttributes?.includes(attributeName)) {
    return { ...baseConfig, disabled: false };
  }

  return baseConfig;
};
